import { MAX_CART_ITEM_QUANTITY } from '../../constants/cart';
import type { CartItemResponse } from '../../model/cart/cart';

/**
 * The web cart's quantity rule: the server's per-item limit, never above the client-wide cap, and a
 * minimum that can never exceed it. The mobile cart validates its limits differently
 * (`apps/mobile/src/containers/cart/cartQuantity.ts`) and must not switch to this.
 */
export function getCartItemQuantityBounds(item?: Pick<CartItemResponse, 'quantityLimit'>) {
  const max = Math.min(item?.quantityLimit?.max ?? MAX_CART_ITEM_QUANTITY, MAX_CART_ITEM_QUANTITY);
  const min = Math.min(item?.quantityLimit?.min ?? 1, max);
  return { min, max };
}
